import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

// components
import { CButton, CImage } from '@coreui/react-pro'
import AppCard from '../../components/AppCard'
import AppTable from 'src/components/AppTable'
import AppModalConfirmation from 'src/components/modal/AppModalConfirmation'

// icons
import AddMoreIconWhite from '../../assets/icons/AddMoreIconWhite.png'

// styling
import { styleButtonVars2 } from '../../components/custom-styles/buttonStyles'

// helpers
import Axios from '../../helpers/axios'
import { columnCompanyPolicyList } from '../../components/table-column/TableColumnList'
import { formUrlQuery } from '../../helpers/format-queries'
import useToastMessage from 'src/helpers/toast-message'

const CompanyPolicyList = () => {
  const navigate = useNavigate()
  const { showSuccess, showError } = useToastMessage();

  const [showConfirmDelete, setShowConfirmDelete] = useState({ show: false, item: {} })

  const [companyPolicyList, setCompanyPolicyList] = useState([]);
  const [companyPolicyListCount, setCompanyPolicyListCount] = useState(0);
  const [companyPolicyListPerPage, setCompanyPolicyListPerPage] = useState(10);
  const [activeCompanyPolicyListPage, setActiveCompanyPolicyListPage] = useState(1);
  const [searchCompanyPolicyListFilter, setSearchCompanyPolicyListFilter] = useState("");
  const [columnCompanyPolicyListSorter, setColumnCompanyPolicyListSorter] = useState({ column: "updatedAt", state: "desc" });

  useEffect(() => {
    let queries = {
      search: searchCompanyPolicyListFilter,
      limit: companyPolicyListPerPage,
      offset: companyPolicyListPerPage * activeCompanyPolicyListPage - companyPolicyListPerPage,
      sort:
        (columnCompanyPolicyListSorter &&
          `${columnCompanyPolicyListSorter.column}%${columnCompanyPolicyListSorter.state}`) ||
        "",
    };
    queries = formUrlQuery(queries);
    fetchAllCompanyPolicies(queries);
  }, [
    searchCompanyPolicyListFilter,
    companyPolicyListPerPage,
    activeCompanyPolicyListPage,
    columnCompanyPolicyListSorter,
  ]);

  const handleSearchItems = (search) => {
    setActiveCompanyPolicyListPage(1)
    setSearchCompanyPolicyListFilter(search);
  }

  const fetchAllCompanyPolicies = (queries) => {
    Axios({
      method: "get",
      url: `/api/tracker/v1/company-policy?${queries}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          let tempCompanyPolicyList = data?.value
          setCompanyPolicyList(tempCompanyPolicyList);
          if (activeCompanyPolicyListPage === 1) {
            setCompanyPolicyListCount(data?.count);
          }
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  };

  const handleDeleteConfirmation = () => {
    Axios({
      method: "delete",
      url: `/api/tracker/v1/company-policy/delete/${showConfirmDelete?.item?.id}`,
    })
      .then(({ data }) => {
        if (data?.success) {
          setShowConfirmDelete({ show: false, item: {} })
          fetchAllCompanyPolicies()
          showSuccess('Company policy has been successfully deleted')
          window.location.reload()
        }
      })
      .catch((err) => {
        console.error(err);
        const errMsg = err?.response?.data?.message
        showError(errMsg)
      });
  }

  const handleOnRowClick = (item, columnName) => {
    if (columnName !== 'action') {
      navigate(`/company-policy/details/${item.id}`)
    }
  }

  return (
    <>
      {
        showConfirmDelete?.show && (
          <AppModalConfirmation 
            confirmationType='delete-item'
            itemName={`Company Policy ${showConfirmDelete?.item?.name}`}
            itemDetails={showConfirmDelete.item}
            itemType={showConfirmDelete.type}
            itemIndex={showConfirmDelete?.index}
            showModal={showConfirmDelete}
            setShowModal={setShowConfirmDelete}
            handleConfirmation={handleDeleteConfirmation}
          />
        )
      }
      <div className='d-grid gap-2 d-flex justify-content-end mb-3'>
        <CButton style={styleButtonVars2} onClick={() => navigate('/company-policy/add')}>
          <CImage fluid src={AddMoreIconWhite} className='me-2' />
          Add Company Policy
        </CButton>
      </div>
      <AppCard 
        className='mb-4'
        headerTitle={<h4>Company Policy List</h4>}
        bodyContent={
          <AppTable
            companyPolicyListPage
            tableFilter
            setShowConfirmDelete={setShowConfirmDelete}
            tableColumns={columnCompanyPolicyList}
            tableContent={companyPolicyList}
            contentPerPage={companyPolicyListPerPage}
            activeContentPage={activeCompanyPolicyListPage}
            contentCount={companyPolicyListCount}
            searchContentFilter={searchCompanyPolicyListFilter}
            setActiveContentPage={setActiveCompanyPolicyListPage}
            setSearchContentFilter={handleSearchItems}
            setContentPerPage={setCompanyPolicyListPerPage}
            setColumnContentSorter={setColumnCompanyPolicyListSorter}
            handleOnRowClick={handleOnRowClick}
            isClickable={true}
          />
        }
      />
    </>
  )
}

export default CompanyPolicyList